import ApiClient from '@/libs/http-client'

const InventoryService = {
    endpoints(route, param = '') {
        const url = {
            inventory: `api/equipments/${param}`,
            categories: `api/equipment-categories`,
        }
        return url[route]
    },
    get(url, param = '') {
        return ApiClient.get(this.endpoints(url, param))
    },
    post(url, data) {
        return ApiClient.post(this.endpoints(url), data)
    },
    put(url, id, data) {
        return ApiClient.put(this.endpoints(url, id), data)
    },
    delete(url, id) {
        return ApiClient.delete(this.endpoints(url, id))
    },
}

export default InventoryService
